import axios, { AxiosResponse } from 'axios';
const timeout = process.env.REACT_APP_TIMEOUT ?? '90000';
const axios_timeout = parseInt(timeout);
export function get(url: string): Promise<AxiosResponse> {
  return axios.get(url, {
    timeout: axios_timeout
  });
}

export function post(url: string, data: any): Promise<AxiosResponse> {
  return axios.post(url, data);
}

export function put(url: string, data: any): Promise<AxiosResponse> {
  return axios.put(url, data);
}

export function _delete(url: string, data?: any): Promise<AxiosResponse> {
  if (!!data) {
    return axios.delete(url, { data });
  }

  return axios.delete(url);
}

export function patch(url: string, data?: any): Promise<AxiosResponse> {
  return axios.patch(url, data);
}
